import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

import { BreadcrumbBuilder } from '../../../../../shared/ui/breadcrumb/breadcrumb-builder';

@Component({
    templateUrl: './inventory.component.html',
    styleUrls: ['./inventory.component.scss'],
})
export class AdminInventoryComponent implements OnInit {
    subscriptionRoute: Subscription;
    pageTitle: string;
    currentUrl: string;

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private breadcrumbBuilder: BreadcrumbBuilder
    ) {}

    ngOnInit(): void {
        this.breadcrumbBuilder.clear();
        this.breadcrumbBuilder.add({
            label: 'Admin / Inventory ',
            url: '/inventory',
        });
        this.setCurrentUrl((<any>this.activatedRoute.snapshot)._routerState.url);
        this.router.events.subscribe((event: any) => {
            if (event instanceof NavigationEnd) {
                this.setCurrentUrl(event.url);
            }
        });

        this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
            const childRoute = this.activatedRoute.firstChild;
            if (childRoute && childRoute.snapshot.data) {
                this.pageTitle = childRoute.snapshot.data['title'];
            }
        });

        const initialChildRoute = this.activatedRoute.firstChild;
        if (initialChildRoute && initialChildRoute.snapshot.data) {
            this.pageTitle = initialChildRoute.snapshot.data['title'];
        }
    }

    setCurrentUrl(url: string) {
        this.currentUrl = url;
    }
}
